module.exports = __webpack_public_path__ + "static/media/klaviyo.9746ae4c.svg";